import {useContext, useEffect, useMemo, useReducer, useState} from 'react';
import { ThemeContext } from '../../services/globalContext';
import {Box, Button, Container, Grid, Typography, useTheme} from "@mui/material";
import {useGetUsersAccountConnect} from "../../hooks/queries/useUsers";

const clientId = process.env.REACT_APP_DISCORD_CLIENT_ID;
const redirectUri = '/discord'

function Integrations() {
  const themeContext = useContext(ThemeContext);
  const theme = useTheme();

  const handleAuthClick = () => {
    const scopes = encodeURIComponent('identify email');
    const encodedRedirectUri = encodeURIComponent(window.location.origin + redirectUri);
    const authorizationUrl = `https://discord.com/oauth2/authorize?client_id=${clientId}&redirect_uri=${encodedRedirectUri}&response_type=token&scope=${scopes}`;

    window.location.href = authorizationUrl;
  };

  const {isLoading, error, data} = useGetUsersAccountConnect();

  const discordIntegrated = useMemo(() => {
    return data?.data.find((integration: any) => integration.connection === 'DISCORD');
  }, [data]);

  return (
    <Container>
      <Box>
        <Typography variant="h2">Discord</Typography>
        <Typography>
          Easily integrate your Discord account with Pinata to be able to pin media from Discord.
        </Typography>
        {discordIntegrated ? <Button disabled>Already integrated</Button>
          : <Button onClick={handleAuthClick}>Add Integration</Button>
        }
      </Box>
    </Container>
  );
}

export default Integrations;
